import {
  DialogTrigger,
  Link,
  LinkButton,
  Popover,
  PopoverContent,
} from "@certn/cascadia-react";
import { Trans } from "react-i18next";

export function DefaultPackageWhatsThis() {
  return (
    <DialogTrigger>
      <LinkButton testID="" textStyle="form/body-secondary-link">
        <Trans>What's this?</Trans>
      </LinkButton>
      <Popover placement="top right">
        <PopoverContent>
          <Trans>
            To run a check with a non-default package, add the package name in
            the tags field. If it matches, it will override the default package
            set for Lever.{" "}
            <Link
              testID="default-package-whats-this-learn-how-link"
              textColor="text-weak"
              href="https://help.certn.co/hc/en-us/articles/1500012707921-Certn-Lever-integration-user-guide#h_01HFFHXNKM0PBC0FCNYW5RJA1H"
              target="_blank"
            >
              Learn how
            </Link>
          </Trans>
        </PopoverContent>
      </Popover>
    </DialogTrigger>
  );
}
